import { __awaiter, __generator, __makeTemplateObject } from "tslib";
/* eslint-disable max-len */

/** @jsx jsx */

import { useEffect, useState, Fragment } from 'react';
import { css, jsx } from '@emotion/react';
import { InputText, Button, Text, useTheme, View, Check, Texts } from '@ion-ui/core';

var InputWrapper = function InputWrapper(_a) {
  var children = _a.children;
  return jsx(View, {
    css: wrapperStyles
  }, jsx(View, {
    css: subWrapperStyle
  }, children));
};

export var ContactView = function ContactView(_a) {
  var setScreen = _a.setScreen,
      createLeadCallback = _a.createLeadCallback,
      setLoader = _a.setLoader,
      setThanksName = _a.setThanksName,
      simulationID = _a.simulationID,
      setUser = _a.setUser,
      monto = _a.monto,
      noticeOfPrivacy = _a.noticeOfPrivacy,
      hubspotButtonsCallback = _a.hubspotButtonsCallback,
      productType = _a.productType,
      isMultisimulator = _a.isMultisimulator,
      heroLayout = _a.heroLayout;
  var theme = useTheme();

  var _b = useState(true),
      enableButton = _b[0],
      setEnableButton = _b[1];

  var _c = useState(''),
      name = _c[0],
      setName = _c[1];

  var _d = useState('none'),
      nameValidation = _d[0],
      setNameValidation = _d[1];

  var _e = useState('none'),
      phoneValidation = _e[0],
      setPhoneValidation = _e[1];

  var _f = useState(''),
      phone = _f[0],
      setPhone = _f[1];

  var _g = useState(''),
      email = _g[0],
      setEmail = _g[1];

  var _h = useState('none'),
      emailValidation = _h[0],
      setEmailValidation = _h[1];

  var _j = useState(false),
      userExists = _j[0],
      setUserExists = _j[1];

  var _k = useState(false),
      phoneExists = _k[0],
      setPhoneExists = _k[1];

  var createLead = function createLead(phone, name, email) {
    return __awaiter(void 0, void 0, void 0, function () {
      var user, mustBeRedirected;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            user = {
              simulation_id: simulationID,
              name: name,
              phone_number: phone,
              email: email
            };
            setLoader(true);
            return [4
            /*yield*/
            , createLeadCallback(user)];

          case 1:
            mustBeRedirected = _a.sent();
            setUser(user);
            setLoader(false);

            if (mustBeRedirected === 'user_exists') {
              setUserExists(true);
              setEmailValidation('danger');
              return [2
              /*return*/
              , false];
            }

            if (mustBeRedirected === 'phone_exists') {
              setPhoneExists(true);
              setPhoneValidation('danger');
              return [2
              /*return*/
              , false];
            }

            if (mustBeRedirected === 'both_exists') {
              setPhoneExists(true);
              setUserExists(true);
              setPhoneValidation('danger');
              setEmailValidation('danger');
              return [2
              /*return*/
              , false];
            }

            if (mustBeRedirected) {
              setScreen(3);
              return [2
              /*return*/
              , true];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  useEffect(function () {
    setPhone('');
    setEmail('');
    setName('');
  }, [monto]);
  var phraseStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding : 0 1.25rem 0 1.25rem;\n    font-family: Grotta;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 0.625rem;\n    line-height: 0.875rem;\n    text-align: center;\n    letter-spacing: 0.01rem;\n    margin:0;\n    text-align:left;\n    color: ", ";\n  "], ["\n    padding : 0 1.25rem 0 1.25rem;\n    font-family: Grotta;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 0.625rem;\n    line-height: 0.875rem;\n    text-align: center;\n    letter-spacing: 0.01rem;\n    margin:0;\n    text-align:left;\n    color: ", ";\n  "])), theme.colors.scales.gray[5]);
  var phraseStyleLato = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding : 0 1.25rem 0 1.25rem;\n    font-family: LATO;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    text-align: center;\n    letter-spacing: 0.01rem;\n    font-weight:400;\n    text-align:left;\n    color: ", ";\n    margin:0;\n  "], ["\n    padding : 0 1.25rem 0 1.25rem;\n    font-family: LATO;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    text-align: center;\n    letter-spacing: 0.01rem;\n    font-weight:400;\n    text-align:left;\n    color: ", ";\n    margin:0;\n  "])), theme.colors.scales.gray[5]);
  useEffect(function () {
    if (emailValidation == 'success' && nameValidation === 'success') {// setEnableButton(true)
    } else {// setEnableButton(false)
    }
  }, [phone, emailValidation, nameValidation]);

  var normalLayout = function normalLayout() {
    return jsx(Fragment, null, userExists && !phoneExists ? jsx(Text, {
      css: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"], ["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"]))),
      variant: 'label'
    }, "Tu correo ya est\xE1 registrado") : null, !userExists && phoneExists ? jsx(Text, {
      css: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"], ["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"]))),
      variant: 'label'
    }, "Tu tel\xE9fono ya est\xE1 registrado") : null, userExists && phoneExists ? jsx(Text, {
      css: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"], ["color:#D6411C; position: absolute;\n          width: 100%;\n          text-align: center;\n          bottom: 60px;"]))),
      variant: 'label'
    }, "Tu tel\xE9fono y correo ya est\xE1n registrados") : null, userExists || phoneExists ? jsx(Button, {
      id: 'login',
      style: {
        width: '21.4rem',
        position: 'absolute',
        bottom: 0
      },
      variant: 'default',
      size: 'md',
      onClick: function onClick() {
        if (window) {
          window.location.replace('http://ion.com.mx/?lg=1');
          return;
        }
      }
    }, jsx(Text, {
      variant: 'button'
    }, "Iniciar sesi\xF3n")) : jsx(Button, {
      style: {
        width: '21.4rem',
        marginTop: '2rem'
      },
      disabled: !(phoneValidation === 'success' && nameValidation === 'success' && emailValidation === 'success' && !enableButton),
      variant: 'default',
      size: 'md',
      onClick: function onClick() {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , createLead(phone, name, email)];

              case 1:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }, jsx(Text, {
      variant: 'button'
    }, "CONTINUAR")));
  };

  var latoLayout = function latoLayout() {
    return jsx(Fragment, null, userExists && !phoneExists ? jsx(Texts, {
      css: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["color:#D6411C; margin-top:6rem; text-transform:initial;"], ["color:#D6411C; margin-top:6rem; text-transform:initial;"]))),
      weight: 'regular',
      size: 'small',
      variant: 'label'
    }, "Tu correo ya est\xE1 registrado") : null, !userExists && phoneExists ? jsx(Texts, {
      css: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["color:#D6411C; margin-top:6rem; text-transform:initial;"], ["color:#D6411C; margin-top:6rem; text-transform:initial;"]))),
      weight: 'regular',
      size: 'small',
      variant: 'label'
    }, "Tu tel\xE9fono ya est\xE1 registrado") : null, userExists && phoneExists ? jsx(Texts, {
      css: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["color:#D6411C; margin-top:6rem; text-transform:initial;"], ["color:#D6411C; margin-top:6rem; text-transform:initial;"]))),
      weight: 'regular',
      size: 'small',
      variant: 'label'
    }, "Tu tel\xE9fono y correo ya est\xE1n registrados") : null, userExists || phoneExists ? jsx(Button, {
      id: 'login',
      style: {
        width: '21.4rem',
        position: 'absolute',
        bottom: '5rem'
      },
      variant: 'default',
      size: 'md',
      onClick: function onClick() {
        if (window) {
          window.location.replace('http://ion.com.mx/?lg=1');
          return;
        }
      }
    }, jsx(Texts, {
      variant: 'button'
    }, "Iniciar sesi\xF3n")) : jsx(Button, {
      style: {
        width: '21.4rem',
        marginTop: '2rem'
      },
      disabled: !(phoneValidation === 'success' && nameValidation === 'success' && emailValidation === 'success' && !enableButton),
      variant: 'default',
      size: 'md',
      onClick: function onClick() {
        var res = createLead(phone, name, email);

        if (hubspotButtonsCallback && res) {
          hubspotButtonsCallback(isMultisimulator ? 'Lead_' + productType : 'Single_Lead_' + productType);
        }
      }
    }, jsx(Texts, {
      size: 'medium',
      weight: 'bold',
      variant: 'button'
    }, "CONTINUAR")));
  };

  return jsx(View, {
    css: mainContent
  }, jsx(View, {
    css: css(templateObject_9 || (templateObject_9 = __makeTemplateObject([" height: 18.5rem;"], [" height: 18.5rem;"])))
  }, jsx(InputText, {
    variant: 'default',
    label: "\xBFCu\xE1l es tu nombre completo?",
    value: name,
    intent: nameValidation,
    autoFocusIndex: 0,
    style: {
      fontFamily: 'Grotta'
    },
    autoFocusDelay: 600,
    onChange: function onChange(e) {
      var nameVal = e.target.value.replace(/(^\w{1})|(\s{1}\w{1})/g, function (match) {
        return match.toUpperCase();
      });
      setName(nameVal);

      if (nameVal.length > 5) {
        setThanksName(nameVal);
        setNameValidation('success');
      } else {
        setNameValidation('danger');
      }
    },
    setEraseValue: function setEraseValue() {
      setName('');
      setNameValidation('none');
    }
  }), jsx(InputText, {
    value: phone,
    intent: phoneValidation,
    label: "\xBFCu\xE1l es tu n\xFAmero de celular?",
    variant: 'phone',
    helperStyles: {
      color: '#D6411C',
      display: phoneExists ? 'block' : 'none'
    },
    helper: 'Número de celular ya registrado',
    style: {
      fontFamily: 'Grotta',
      fontSize: '0.875rem'
    },
    mask: '(00) 000 000 00',
    placeholder: '(00) 000 000 00',
    countryCode: 'MX',
    autoFocusIndex: 0,
    autoFocusDelay: 600,
    focusOnDisplay: true,
    onChange: function onChange(e) {
      var phoneVal = e.target.value;
      var re = /[^\d]/g;
      phoneVal = phoneVal.replace(re, '');
      setPhoneExists(false);

      if (phoneVal.length === 12) {
        setPhone('+' + phoneVal);
      }

      if (phoneVal.length >= 12) {
        setPhoneValidation('success');
      } else {
        setPhoneValidation('danger');
      }
    },
    setEraseValue: function setEraseValue() {
      setPhone('');
      setPhoneValidation('none');
    }
  }), jsx(InputText, {
    value: email,
    variant: 'default',
    style: {
      fontFamily: 'Grotta'
    },
    helper: 'Correo ya registrado, por favor inicia sesión',
    helperStyles: {
      color: '#D6411C',
      display: userExists ? 'block' : 'none'
    },
    label: "\xBFCu\xE1l es tu correo electr\xF3nico?",
    intent: emailValidation,
    onChange: function onChange(e) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      setUserExists(false);

      if (re.test(String(e.target.value).toLowerCase())) {
        setEmailValidation('success');
      } else {
        setEmailValidation('danger');
      }

      setEmail(e.target.value);
    },
    setEraseValue: function setEraseValue() {
      setEmail('');
      setEmailValidation('none');
    }
  }), jsx(View, {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: heroLayout ? '0.75rem' : '0.85rem'
    }
  }, jsx(View, {
    style: {
      width: '30%'
    }
  }, jsx(Check, {
    simulador: true,
    id: 'checkLegacy',
    css: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["width : 0%; margin-top:0.625rem"], ["width : 0%; margin-top:0.625rem"]))),
    style: {
      width: '0%',
      marginTop: '0.625rem'
    },
    onClick: function onClick() {
      setEnableButton(!enableButton);
    },
    label: '',
    labelTextStyles: {
      fontSize: '0.875rem'
    }
  })), !heroLayout ? jsx("p", {
    css: phraseStyle
  }, "Acepto que he le\xEDdo el ", jsx("a", {
    id: 'privacy',
    css: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["color:", "; cursor:pointer;"], ["color:", "; cursor:pointer;"])), theme.colors.scales.blue[5]),
    onClick: function onClick(e) {
      e.preventDefault();
      noticeOfPrivacy();
    }
  }, "Aviso de Privacidad"), " y manifiesto mi consentimiento para el tratamiento de mis datos personales (inclusive patrimoniales y financieros) para los fines de la presente simulaci\xF3n de cr\xE9dito.") : jsx("p", {
    css: phraseStyleLato
  }, "Acepto que he le\xEDdo el ", jsx("a", {
    id: 'privacy',
    css: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["color:", "; cursor:pointer;"], ["color:", "; cursor:pointer;"])), theme.colors.scales.blue[5]),
    onClick: function onClick(e) {
      e.preventDefault();
      noticeOfPrivacy();
    }
  }, "Aviso de Privacidad"), " y manifiesto mi consentimiento para el tratamiento de mis datos personales (inclusive patrimoniales y financieros) para los fines de la presente simulaci\xF3n de cr\xE9dito."))), jsx(View, {
    css: contactStyle
  }, !heroLayout ? normalLayout() : latoLayout()));
};
var contactStyle = css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;"])));
var mainContent = css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display:flex;\n  flex-direction:column;\n  justify-content:space-between;\n  align-items:center;\n"], ["\n  display:flex;\n  flex-direction:column;\n  justify-content:space-between;\n  align-items:center;\n"])));
var wrapperStyles = css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content:center;\n    margin-top: 0.938rem;\n    height:55%;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content:center;\n    margin-top: 0.938rem;\n    height:55%;\n"])));
var subWrapperStyle = css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    flex-direction: column;\n    display: flex;\n    justify-content:space-around;\n"], ["\n    flex-direction: column;\n    display: flex;\n    justify-content:space-around;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;